import {
  BACKORDER_LABEL,
  OUT_OF_STOCK_LABEL,
  type StockAvailability,
} from '@/lib/catalog/availability';

/** Cart / checkout line marker for items with no stock. Renders nothing when in stock. */
export function AvailabilityBadge({ availability }: { availability: StockAvailability }) {
  if (availability === 'in_stock') return null;
  return availability === 'backorder' ? (
    <span className="ml-1 inline-flex items-center rounded bg-amber-50 px-1.5 py-0.5 text-[10px] font-semibold text-amber-800">
      {BACKORDER_LABEL}
    </span>
  ) : (
    <span className="ml-1 inline-flex items-center rounded bg-red-50 px-1.5 py-0.5 text-[10px] font-semibold text-red-800">
      {OUT_OF_STOCK_LABEL} — remove to check out
    </span>
  );
}
